export enum PhotoSortingType {
  Newest,
  Oldest
}
